<!--
 * @Author: your name
 * @Date: 2020-05-16 09:40:48
 * @LastEditTime: 2020-05-21 11:15:25
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/ResearchPart2.vue
 -->
<template>
  <div class="ResearchPart2" :style="`background: url('${require('../assets/research/bg1.png')}') no-repeat; background-size: 100% 100%;`">
    <div class="body">
        <div class="intro">
            <p class="text">
            为助力紧密型县域医共体建设、更好服务基层百姓健康，人民网·人民健康举办 “后疫情时代 县域医共体建设的思考”直播活动。同时为更好的了解全国紧密型县域医共体实施情况，请您协助填写调查问卷，并在线提交即可。您提供的所有信息仅限调查使用且受到严格保护，我们期待您的意见和建议！
            </p>
            <p class="text">感谢您对此项工作的支持与帮助！</p>
        </div>
        <div class="operating">
            <van-button class="upPage" @click="upPage()">上一页</van-button>
            <van-button class="downPage" @click="downPage()">下一页</van-button>
        </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'

export default {
  name: 'ResearchNoWeChatPart2',
  data() {
    return {
        openid: '', 
    };
  },
  methods: {
      upPage() {
          this.$router.go(-1)
      },
      downPage() {
           this.$router.push({ name: "ResearchNoWeChatPart3"})
      } 
  },
  mounted: function() {
    // this.openid = Cookies.get('openid')
    // // 跳转到首页
    // if(!this.openid){
    //     this.$router.push({ name: "ResearchPart2"})
    // }
  },
}
</script>

<style lang="less" scoped>
.ResearchPart2 {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    .body {
        .intro {
            opacity: 0.8;
            background: #FFFFFF;
            border-radius: 10px;
            border-radius: 10px;
            padding: 30px 20px;
            margin: 20px 16px;
            .text {
                font-family: PingFangSC-Regular;
                font-size: 18px;
                color: #000000;
                letter-spacing: 0;
            }
        }
        .operating {
            text-align: center;
            .upPage {
                background: #FFFFFF;
                border-radius: 40px;
                border-radius: 40px;
                width: 36%;
                height: 45px;
            }
            .downPage {
                background: #F6A763;
                border-radius: 40px;
                border-radius: 40px;
                width: 36%;
                height: 45px;
            }
        }
     }
     .van-button--default {
        border: 1px solid #1d74f7;
     }
}
</style>


// WEBPACK FOOTER //
// src/components/ResearchNoWeChatPart2.vue